import { ReactElement } from 'react';

import { ReservationPreference } from '@dreryk/egabinet-waitlist-frontend-api';

import { BindingCreator, useTranslate } from '@dreryk/react-common';
import { FilterPanel, Select } from '@dreryk/react-components';

import {
   WaitlistFilterPanelFormBean,
   WaitlistFilterPanelSearchParam,
   WaitlistFilterPanelStorageKey,
} from '../../WaitlistFilterPanel.types';
import { translationKeys } from '../../../translations';
import { RESERVATION_PREFERENCES } from '../../../shared/reservationPreference';

import {
   createReservationPreferenceTriggerLabelExtractor,
   reservationPreferenceCodec,
   reservationPreferenceDeselectorsPropsMapper,
} from './ReservationPreferenceController.utils';
import { StyledReservationPreferenceSelect } from './ReservationPreferenceSelect.styled';

type ReservationPreferenceControllerProps = {
   registerController: BindingCreator<WaitlistFilterPanelFormBean, 'reservationPreference'>;
};

export const ReservationPreferenceController = (props: ReservationPreferenceControllerProps): ReactElement => {
   const translate = useTranslate();
   return (
      <FilterPanel.Controller<WaitlistFilterPanelFormBean, 'reservationPreference'>
         name={'reservationPreference'}
         searchParam={WaitlistFilterPanelSearchParam.RESERVATION_PREFERENCE}
         storageKey={WaitlistFilterPanelStorageKey.RESERVATION_PREFERENCE}
         codec={reservationPreferenceCodec}
         chipsLabel={translationKeys.priority}
         getDeselectorsProps={reservationPreferenceDeselectorsPropsMapper}
      >
         {({ applyFilter }) => (
            <StyledReservationPreferenceSelect<ReservationPreference>
               testId={'reservationPreference'}
               triggerLabelExtractor={createReservationPreferenceTriggerLabelExtractor(translate)}
               controller={props.registerController('reservationPreference')}
               onHide={applyFilter}
               label={translationKeys.priority}
               placeholder={translationKeys.choosePriority}
               compact
            >
               <>
                  <Select.List<ReservationPreference> items={RESERVATION_PREFERENCES}>
                     {(item) => (
                        <Select.Item
                           item={item}
                           label={translationKeys.reservationPreferenceMapUppercase[item]}
                           testId={item}
                        />
                     )}
                  </Select.List>
               </>
            </StyledReservationPreferenceSelect>
         )}
      </FilterPanel.Controller>
   );
};
